module.exports = __webpack_public_path__ + "static/img/图层60.736d422.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层60.png
// module id = 1raR
// module chunks = 0